var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0416 17H9.2416C9.08247 17 8.92986 16.9368 8.81734 16.8243C8.70482 16.7117 8.6416 16.5591 8.6416 16.4V14.1C8.6416 13.9409 8.57839 13.7883 8.46587 13.6757C8.35334 13.5632 8.20073 13.5 8.0416 13.5H5.7416C5.58247 13.5 5.42986 13.4368 5.31734 13.3243C5.20482 13.2117 5.1416 13.0591 5.1416 12.9V9.1C5.1416 8.94087 5.20482 8.78826 5.31734 8.67574C5.42986 8.56321 5.58247 8.5 5.7416 8.5H8.0416C8.20073 8.5 8.35334 8.43679 8.46587 8.32426C8.57839 8.21174 8.6416 8.05913 8.6416 7.9V5.6C8.6416 5.44087 8.70482 5.28826 8.81734 5.17574C8.92986 5.06321 9.08247 5 9.2416 5H13.0416C13.2007 5 13.3533 5.06321 13.4659 5.17574C13.5784 5.28826 13.6416 5.44087 13.6416 5.6V7.9C13.6416 8.05913 13.7048 8.21174 13.8173 8.32426C13.9299 8.43679 14.0825 8.5 14.2416 8.5H16.5416C16.7007 8.5 16.8533 8.56321 16.9659 8.67574C17.0784 8.78826 17.1416 8.94087 17.1416 9.1V12.9C17.1416 13.0591 17.0784 13.2117 16.9659 13.3243C16.8533 13.4368 16.7007 13.5 16.5416 13.5H14.2416C14.0825 13.5 13.9299 13.5632 13.8173 13.6757C13.7048 13.7883 13.6416 13.9409 13.6416 14.1V16.4C13.6416 16.5591 13.5784 16.7117 13.4659 16.8243C13.3533 16.9368 13.2007 17 13.0416 17Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1416 21C16.6646 21 21.1416 16.523 21.1416 11C21.1416 5.477 16.6646 1 11.1416 1C5.6186 1 1.1416 5.477 1.1416 11C1.1416 16.523 5.6186 21 11.1416 21Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmacy);
export default __webpack_public_path__ + "static/media/pharmacy.83e06ea6b7f90ff87381d48bb1502396.svg";
export { ForwardRef as ReactComponent };